import React from "react";
import "./HeaderComponent.scss";

export default function HeaderComponent() {
  return <header>Traceably.io</header>;
}
